if (!window.packSwap) {
  window.packSwap = (function () {
    let cache = new Map();
    let currentPath = window.location.pathname;
    let swapTargets = [
      '.product-info-mobile',
      '.product__media-wrapper',
      '.product__info-container > .product-title',
      '.product__info-container > [id^="price-"]',
      '.product-options-listo',
      'product-form.product-form',
      'script[data-pack-swap]',
    ];

    let mainSectionId = function () {
      let section = document.querySelector('.shopify-section[id^="shopify-section-template--"][id$="__main"]');
      return section ? section.id.replace('shopify-section-', '') : '';
    };

    let baseColor = function (color) {
      return (color || '').toLowerCase().replace(/ mix$/, '').trim();
    };

    let selectedColor = function () {
      let input = document.querySelector('[id$="__main"] .value-grid[data-option="color"] input:checked');
      return input ? input.value : '';
    };

    let warmImages = function (sections, color, timeout) {
      let template = document.createElement('template');
      template.innerHTML = Object.values(sections).join('');
      let slides = Array.from(template.content.querySelectorAll('.product-gallery .main-container .swiper-slide'));
      let hasColorSlides = slides.some((slide) => baseColor(slide.dataset.color) === baseColor(color));
      let colorSlides = slides.filter((slide) => baseColor(slide.dataset.color) === baseColor(color) || (hasColorSlides && baseColor(slide.dataset.color) === 'all'));
      let gallery = (colorSlides.length ? colorSlides : slides).slice(0, 2).map((slide) => slide.querySelector('img'));
      let swatches = Array.from(template.content.querySelectorAll('.value-grid[data-option="color"] img'));
      let decodes = [...gallery, ...swatches].filter(Boolean).map((source) => {
        let image = new Image();
        if (source.sizes) image.sizes = source.sizes;
        if (source.srcset) image.srcset = source.srcset;
        image.src = source.src;
        return image.decode().catch(() => {});
      });
      return Promise.race([Promise.all(decodes), new Promise((resolve) => setTimeout(resolve, timeout))]);
    };

    let load = function (path) {
      if (!cache.has(path)) {
        let request = fetch(`${path}?sections=${mainSectionId()}`)
          .then((response) => {
            if (!response.ok) throw new Error(`Pack swap failed with ${response.status}`);
            return response.json();
          })
          .then((sections) => warmImages(sections, selectedColor(), 1500).then(() => sections))
          .catch((error) => {
            cache.delete(path);
            throw error;
          });
        cache.set(path, request);
      }
      return cache.get(path);
    };

    let replaceWithFresh = function (current, fresh) {
      let holder = document.createElement('div');
      HTMLUpdateUtility.setInnerHTML(holder, fresh.outerHTML);
      let inserted = holder.firstElementChild;
      current.replaceWith(...holder.childNodes);
      return inserted;
    };

    let quickFadeTargets = [
      '.product-info-mobile',
      '.product__info-container > .product-title',
      '.product__info-container > [id^="price-"]',
    ];

    let quickFadeIn = function (elements) {
      if (!elements.length) return;
      getComputedStyle(elements[0]).opacity;
      elements.forEach((element) => {
        element.style.transition = 'opacity 0.15s ease-in-out';
        element.style.opacity = '';
      });
    };

    let fadeInWhenReady = function (wrapper) {
      let gallery = wrapper.querySelector('.product-gallery');
      let revealed = false;
      let reveal = function () {
        if (revealed) return;
        revealed = true;
        requestAnimationFrame(function () {
          wrapper.style.transition = 'opacity 0.3s ease-in-out';
          wrapper.style.opacity = '';
        });
      };
      if (!gallery || gallery.classList.contains('is-ready')) return reveal();
      let observer = new MutationObserver(function () {
        if (!gallery.classList.contains('is-ready')) return;
        observer.disconnect();
        reveal();
      });
      observer.observe(gallery, { attributes: true, attributeFilter: ['class'] });
      setTimeout(reveal, 1000);
    };

    let swapGallery = function (current, fresh) {
      current.style.transition = 'opacity 0.3s ease-in-out';
      current.style.opacity = '0';
      setTimeout(function () {
        fresh.style.opacity = '0';
        fadeInWhenReady(replaceWithFresh(current, fresh));
      }, 300);
    };

    let render = function (sections) {
      let html = sections[mainSectionId()];
      let productInfo = document.querySelector(`#shopify-section-${mainSectionId()} product-info`);
      if (!html || !productInfo) throw new Error('Pack swap is missing the main section');
      let template = document.createElement('template');
      template.innerHTML = html;
      let freshInfo = template.content.querySelector('product-info');
      productInfo.abortController?.abort();
      ['data-product-id', 'data-url'].forEach((name) => productInfo.setAttribute(name, freshInfo.getAttribute(name)));
      let fadingIn = [];
      swapTargets.forEach((selector) => {
        let current = productInfo.querySelector(selector);
        let fresh = freshInfo.querySelector(selector);
        if (!current || !fresh) return;
        if (selector === '.product__media-wrapper') {
          swapGallery(current, fresh);
        } else if (quickFadeTargets.includes(selector)) {
          fresh.style.opacity = '0';
          fadingIn.push(replaceWithFresh(current, fresh));
        } else if (current.contains(document.activeElement)) {
          let activeLink = replaceWithFresh(current, fresh).querySelector('a.bundle-link.active');
          if (activeLink) activeLink.focus({ preventScroll: true });
        } else {
          replaceWithFresh(current, fresh);
        }
      });
      quickFadeIn(fadingIn);
      productInfo.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
    };

    let announce = function () {
      let data = document.querySelector('[data-pack-swap]');
      if (!data) return;
      let product = JSON.parse(data.textContent);
      document.title = product.pageTitle;

      if (window._learnq) {
        window._learnq.push(['track', 'Viewed Product', product.klaviyo]);
        window._learnq.push([
          'trackViewedItem',
          {
            Title: product.klaviyo.Name,
            ItemId: product.klaviyo.ProductID,
            Categories: product.klaviyo.Categories,
            ImageUrl: product.klaviyo.ImageURL,
            Url: product.klaviyo.URL,
            Metadata: {
              Brand: product.klaviyo.Brand,
              Price: product.klaviyo.Price,
              Value: product.klaviyo.Value,
              CompareAtPrice: product.klaviyo.CompareAtPrice,
            },
          },
        ]);
      }
    };

    let swap = function (url, fromUrl) {
      let target = new URL(url, window.location.origin);
      let color = new URLSearchParams(target.hash.slice(1)).get('color') || selectedColor();
      return load(target.pathname)
        .then((sections) => warmImages(sections, color, 600).then(() => sections))
        .then((sections) => {
          if (fromUrl) {
            history.replaceState(history.state, '', fromUrl);
            history.pushState({}, '', target.href);
          }
          currentPath = target.pathname;
          render(sections);
          announce();
        })
        .catch(() => {
          window.location.href = target.href;
        });
    };

    let prefetch = function (urls) {
      urls.forEach((url) => {
        let path = new URL(url, window.location.origin).pathname;
        if (path !== currentPath) load(path).catch(() => {});
      });
    };

    window.addEventListener('popstate', function () {
      if (window.location.pathname === currentPath) return;
      swap(window.location.href);
    });

    return { swap, prefetch };
  })();
}
